import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomMoreInfoComponent} from './custom-more-info.component';
import {CustomCmsItemModule} from '../custom-cms-item/custom-cms-item.module';
import {CmsConfig, ConfigModule} from '@spartacus/core';


@NgModule({
  declarations: [CustomMoreInfoComponent],
  exports: [CustomMoreInfoComponent],
  imports: [
    CommonModule,
    CustomCmsItemModule,
    ConfigModule.withConfig({
      cmsComponents: {
        MoreInfoComponent: {
          component: CustomMoreInfoComponent,
        },
      },
    } as CmsConfig),
  ]
})
export class CustomMoreInfoModule { }
